import { Container, Content, RegisterContainer, Infos } from "./styles";

import treepayLogo from '../../assets/treelogo3.svg';
import Stepper from "../../components/stepper";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { StoreState } from '../../store';
import { Link, useNavigate } from "react-router-dom";
import Aside from "../../components/Aside";
export default function Cadastro() {
  const { isLoggedIn } = useSelector((state: StoreState) => state.auth)
  const navigate = useNavigate()
  useEffect(() => {
    if(isLoggedIn) navigate('/home')
  }, [navigate, isLoggedIn])
  return (
    <Container>
      <Aside />
      <Content>
        <RegisterContainer>
          <Infos>
            <a href="/">
              <img src={treepayLogo} alt="Logo treepay" />
            </a>
            <h1>Criar uma conta</h1>
            <p>Preencha todos os campos para dar o próximo passo da sua empresa</p>
          </Infos>
          <Stepper />
        </RegisterContainer>
        <p className="text-center text-base text-gray-700 mt-auto mb-2">Já possui conta? <Link className="text-blue-600 hover:text-blue-500 font-semibold " to='/login'> Entrar</Link></p>
      </Content>
    </Container>
  )
}
